// extracted by mini-css-extract-plugin
module.exports = {"blog__detail":"BlogItem_blog__detail__4lxV_"};